import "./Home.module.css";
import AntetNavigare from "@/reusable_sections/Header";
import HeroProgram from "./sections/HeroProgram";
import ProfilulParticipantului from "./sections/ProfilulParticipantului";
import CurriculumWebinarSiUrgenta from "./sections/CurriculumWebinarSiUrgenta";
import GarantiaExperientei from "./sections/GarantiaExperientei";
import TombolaParticipantilor from "./sections/TombolaParticipantilor";
import FaqSection from "./sections/FaqSection";
import BonusOpportunity from "./sections/BonusOpportunity";
import AudienceProblem from "./sections/AudienceProblem";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <AntetNavigare />
      <HeroProgram />
      <AudienceProblem />
      <ProfilulParticipantului />
      <CurriculumWebinarSiUrgenta />
      <GarantiaExperientei />
      <TombolaParticipantilor />
      <FaqSection />
      <BonusOpportunity />
      <Footer />
    </div>;
}